export default "__VITE_ASSET__i2D352h4__"